/**
 * サイズを日本語ラベルに変換する
 */
export const getSizeLabel = (size: string): string => {
  const sizeMap = {
    'SMALL': '小',
    'MEDIUM': '中',
    'LARGE': '大'
  } as const;
  return sizeMap[size as keyof typeof sizeMap] || size;
};

/**
 * 文字色を日本語ラベルに変換する
 */
export const getColorLabel = (color: string): string => {
  const upperCaseHex = color.toUpperCase();
  const colorMap = {
    '#FFFFFF': '白',
    '#FFFF00': '黄',
    '#FF0000': '赤'
  } as const;
  return colorMap[upperCaseHex as keyof typeof colorMap] || color;
};

/**
 * 背景色を日本語ラベルに変換する
 */
export const getBgColorLabel = (color: string): string => {
  const upperCaseHex = color.toUpperCase();
  const colorMap = {
    '#000000': '黒',
    '#FF0000': '赤'
  } as const;
  return colorMap[upperCaseHex as keyof typeof colorMap] || color;
};

/**
 * 日時を日本語フォーマットで変換する
 */
export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}; 